import { liveStats, STATS_TYPES, AGGREGATION_LEVELS } from '@/mqtt/liveStats'

function answerCountPerAnswerValueTopic(activityId, questionId, version, answerValue) {
  return `${STATS_TYPES.ANSWERER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${activityId}/${version}/${questionId}/${answerValue}`
}

function answerCountPerActivityTopic(activityId, version) {
  return `${STATS_TYPES.ANSWERER_COUNT}/${AGGREGATION_LEVELS.PER_ACTIVITY}/${activityId}/${version}`
}

function averageScorePerQuestionTopic(activityId, version, questionId) {
  return `${STATS_TYPES.AVERAGE_SCORE}/${AGGREGATION_LEVELS.PER_QUESTION}/${activityId}/${version}/${questionId}`
}

function averageScorePerActivityTopic(activityId, version) {
  return `${STATS_TYPES.AVERAGE_SCORE}/${AGGREGATION_LEVELS.PER_ACTIVITY}/${activityId}/${version}`
}

function answererCountPerQuestionTopic(activityId, questionId, version) {
  return `${STATS_TYPES.ANSWERER_COUNT}/${AGGREGATION_LEVELS.PER_QUESTION}/${activityId}/${version}/${questionId}`
}

const _state = {}

const mutations = {
  updateStats(state, statsUpdate) {
    if (!state[statsUpdate.topic]) {
      state[statsUpdate.topic] = {}
    }
    state[statsUpdate.topic] = statsUpdate.message
  },
}

const actions = {
  subscribeStatsAction({ commit }, payload) {
    liveStats.subscribeStat(payload, (topic, message, statsUpdate) => {
      commit('updateStats', {
        topic,
        message,
      })
      if (payload.callback) {
        payload.callback(statsUpdate)
      }
    })
  },
  unsubscribeStatsAction(_, payload) {
    liveStats.unsubscribeStats(payload)
  },
}

const getters = {
  answerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return state[answerCountPerAnswerValueTopic(activityId, questionId, version, answerValue)]
    }
  },
  answerCountPerActivity(state) {
    return (activityId, version) => {
      return state[answerCountPerActivityTopic(activityId, version)]
    }
  },
  answererCountPerQuestion(state) {
    return (activityId, questionId, version) => {
      return state[answererCountPerQuestionTopic(activityId, questionId, version)]
    }
  },
  averageScorePerQuestion(state) {
    return (activityId, version, questionId) => {
      return state[averageScorePerQuestionTopic(activityId, version, questionId)]
    }
  },
  averageScorePerActivity(state) {
    return (activityId, version) => {
      return state[averageScorePerActivityTopic(activityId, version)]
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
